var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0794 0H9.92064C4.44162 0 0 4.44162 0 9.92064V20.0794C0 25.5584 4.44162 30 9.92064 30H20.0794C25.5584 30 30 25.5584 30 20.0794V9.92064C30 4.44162 25.5584 0 20.0794 0Z",
    fill: "#FF002F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24.4163V10.6182H25.8933L18.1057 15.2683L15 24.4163Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 24.4163V10.6182H4.10693L11.8946 15.2683L15.0003 24.4163Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign);
export default __webpack_public_path__ + "static/media/sign.e69e1d42b1dc1f62d881a9080933c1c0.svg";
export { ForwardRef as ReactComponent };